module.exports = __webpack_public_path__ + "img/map-bg.531ef030.svg";